import { useNavigate, useSearchParams } from "react-router-dom";
import { openH5LegalPath, sanitizeH5BackPath } from "./legalLinks";
import { h5NavigateTo } from "../utils/miniProgramEnv";

type Props = {
  linkClassName?: string;
};

/** 登录页协议文案（H5 站内路由打开） */
export function LoginLegalAgreeText(props: Props) {
  const linkClass = props.linkClassName ?? "login-page-agree-link";
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const redirect = sanitizeH5BackPath(searchParams.get("redirect"));
  const back = redirect ? `/login?redirect=${encodeURIComponent(redirect)}` : "/login";

  const openLegal = (slug: "user-agreement" | "privacy") => {
    h5NavigateTo(navigate, openH5LegalPath(slug, back), { state: { back } });
  };

  return (
    <span>
      我已阅读并同意
      <button
        type="button"
        className={linkClass}
        onClick={(e) => {
          e.stopPropagation();
          openLegal("user-agreement");
        }}
      >
        《用户协议》
      </button>
      与
      <button
        type="button"
        className={linkClass}
        onClick={(e) => {
          e.stopPropagation();
          openLegal("privacy");
        }}
      >
        《隐私政策》
      </button>
    </span>
  );
}
